export enum PayoffRequestStatus {
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
}

export interface LossExpressSearchRequest {
  entityName: string;
  accountNumber?: string;
  customerName?: string;
  customerAddress?: string;
  customerBirthdate?: string;
  customerPhoneNumber?: string;
  financeType?: string;
  lenderId?: string;
  lenderName: string;
  socialSecurityNumber?: string;
  vehicleMileage?: number;
  vin: string;
}

export interface LossExpressLender {
  lenderName: string;
  integrated: boolean;
  lenderId: string;
  aliases: string[]
}

export type LossExpressLenderResponse = {
  lenders: LossExpressLender[];
};

export type LossExpressPayoffResponse = {
  id: string;
  deal_id: string;
  vin: string;
  payoff_id: string;
  requestStatus: PayoffRequestStatus;
  payoffExpiredDate?: string;
  data?: { [key: string]: number | string };
};

export enum LossExpressFinanceType {
  Retail = 'Retail',
  Lease = 'Lease',
}

export type LossExpressInitialResponse = {
  success: boolean;
  payoffId: string;
};

export type LossExpressPayoffId = string;
